import React from 'react'
import { l } from '@manychat/manyui'

const EmailIsNotSuspendedNotification = () => {
  return <span>{l.translate('Email sendings was un-suspended')}</span>
}

export default EmailIsNotSuspendedNotification
